
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
    name: "PriVewDialog",
})
export default class extends Vue {
    dialogTableVisible = false;
    mediaList = [];
    preIndex = 0;
    public open(list, index) {
        this.mediaList = list;
        this.preIndex = index;
        this.dialogTableVisible = true;
        console.log(list, index);
    }
    upOrDownStep(num) {
        //0上一张，1下一张
        if (num == 0) {
            if (this.preIndex > 0) {
                this.preIndex--;
            }
        } else {
            if (this.preIndex != this.mediaList.length - 1) {
                this.preIndex++;
            }
        }
    }
    hideModal() {
        this.dialogTableVisible = false;
    }
}
